import React from "react";
import "./style.css";

const Star4 = () => {
  return (
    <div className="star_container">
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/disable_star.png" />
    </div>
  );
};

export default Star4;
